import { dans } from "./projects/dans"
import { nbaScoreboard } from "./projects/nba-scoreboard"
import { getBBallStats } from "./projects/get-bball-stats"

export const projects = [
    dans,
    getBBallStats,
    nbaScoreboard,
]